import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { doOnFirst } from '@app/shared/extra/utils';
import { Idle } from '@ng-idle/core';

@Component({
    templateUrl: './idle-snackbar.component.html',
    styleUrl: './idle-snackbar.component.scss',
    standalone: false
})
export class IdleSnackbarComponent implements OnInit {
  private idle = inject(Idle);
  private destroyRef = inject(DestroyRef);

  public timeoutDelay: number;
  public remaining: number;

  /**
   * Listen for idle timeout values and update this component's delay and remaining seconds.
   */
  public ngOnInit(): void {
    this.idle.onTimeoutWarning.pipe(
      doOnFirst(remaining => this.timeoutDelay = remaining),
      takeUntilDestroyed(this.destroyRef)
    )
      .subscribe(remaining => this.remaining = remaining);
  }
}
